<template>
  <div id="app" ref="elApp">
    <fish-layout ref="elLayout">
      <link rel="shortcut icon" type="image/png" href="/assets/plslogo.png"/>
      <!-- <div slot="header" class="sHeader">
        <fish-row>
          <fish-col span="8" class="text-left"><img src="../dist/img/toonies.png"/></fish-col>
          <fish-col span="8"><b style="font-size:25px">TOONIES DASHBOARD</b></fish-col>
          <fish-col span="8" class="text-right"><img style="width:270px;height:49px" src="../dist/img/pls.png"/></fish-col>
        </fish-row>
      </div> -->
      <div slot="content">
        <Navbar />
        <router-view />
      </div>

      <div slot="footer" class="footer" ref="elFooter">
        <fish-row>
          <fish-col span="8" class="text-left"></fish-col>
          <!-- <fish-col span="8" class="text-left"><img width="100px" src="../dist/img/toonies.png"/></fish-col> -->
          <fish-col span="8">Copyright © 2026 PLS ITS</fish-col>
          <!-- <fish-col span="8"><img width="100px" src="../dist/img/pls.png"/></fish-col> -->
        </fish-row>
      </div>
    </fish-layout>
    <!-- <div slot="footer" class="footer">FooterTEST</div> -->
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
// var mylib = require("../dist/js/adminlte.min.js")
// import { mapState } from "vuex";
// import { mapActions } from "vuex";
export default {
    components: {
        Navbar
    },
  // computed: {
  //   ...mapState(["isLogin", "oUser"]),
  // },
  // methods: {
  // },
};
</script>
<style>
html,
body {
  height: 100%;
  font-size: 12px !important;
}

span,
td {
  font-size: 12px !important;
}
.fish.dimmer {
  background-color: rgba(0, 0, 0, 0.16) !important;
}
.loadLogin.fish.dimmer.loading.active::before {
  content: "Đảng tải";
  padding-top: 34px;
  background-color: rgba(255, 255, 255, 0.64);
  color: red;
  font-weight: bold;
  margin: -3.3em 10em 10em -3.3em;
  width: 100px;
  height: 100px;
}
.loadLogin.fish.dimmer.loading.active::after {
  margin: -3.3em 10em 10em -3.3em;
  width: 100px;
  height: 100px;
}
.fish.notices.top.center {
  top: 5em !important;
}
.fish.notices.top.center .notice.success {
  border-top: 4px solid #21ba45 !important;
  border: 1px solid #21ba45;
}
.fish.notices.top.center .notice.error {
  border-top: 4px solid #db2828 !important;
  border: 1px solid #db2828;
}
.fish.notices.top.center .notice.warning {
  border-top: 4px solid orange !important;
  border: 1px solid orange;
}
.loadApp.fish.dimmer.loading.active::before {
  content: "mất kết nối";
  padding-top: 34px;
  background-color: rgba(255, 255, 255, 0.64);
  color: red;
  font-weight: bold;
  margin: -3.3em 10em 10em -3.3em;
  width: 100px;
  height: 100px;
}
.loadApp.fish.dimmer.loading.active::after {
  margin: -3.3em 10em 10em -3.3em;
  width: 100px;
  height: 100px;
}
.h100 {
  height: 100%;
}
.content {
  /* height: 100%; */
  padding: 10px;
}
.sHeader {
  margin-top: 20px;
  font-size: 16px;
}
/* .footer {
  padding: 20px 0px !important;
  color: white !important;
} */
.footer {
  /* position: absolute; */
  bottom: 0px;
  color: white !important;
  font-size: 13px;
  font-weight: bold;
  margin-top: -10px;
  padding: 0px 10px 0 10px;
  height: 30px;
  left: 0px;
  right: 0px;
  overflow: hidden;
  background-color: #e0f0fa;
}

.fish.card > .content {
  flex: none;
}
.p10 {
  padding-left: 10px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: block;
  overflow: auto;
  height: 100%;
  margin-bottom: -40px;
}
.text-left {
  text-align: left;
  padding-left: 10px;
}
.text-right {
  text-align: right;
  padding-right: 10px;
}
.nav_right {
  float: right;
  width: 50%;
  text-align: right;
}
.nav_left {
  float: right;
  width: 50%;
  text-align: left;
}
.nav_child {
  padding: 0px 10px 0px 10px;
  font-size: 16px;
}
#nav {
  padding: 10px;
  font-size: 16px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

@import "./assets/css/font-awesome.css";
@import "./assets/css/css.css?family=Lato:400,700,400italic,700italic&subset=latin";
</style>
